<div class="layout">
  <router-outlet></router-outlet>
</div>

<nm-notifications class="app__notifications"></nm-notifications>
